import React from 'react';

import { HeaderWrapper, ImageLogo } from "./styles"

interface HeaderProps {
  companyLogo?: string;
}

export const Header = (props: HeaderProps) => {
  const { companyLogo } = props;

  return (
    <HeaderWrapper>
      <ImageLogo src={companyLogo} alt="company-logo" />
    </HeaderWrapper>
  )
}
